export { checkMaxIfStatementsInShader } from './checkMaxIfStatementsInShader.mjs';
export { compileShader } from './compileShader.mjs';
export { defaultValue } from './defaultValue.mjs';
export { generateUniformsSync } from './generateUniformsSync.mjs';
export { getMaxFragmentPrecision } from './getMaxFragmentPrecision.mjs';
export { getTestContext } from './getTestContext.mjs';
export { logProgramError } from './logProgramError.mjs';
export { mapSize } from './mapSize.mjs';
export { mapType } from './mapType.mjs';
export { setPrecision } from './setPrecision.mjs';
export { uniformParsers } from './uniformParsers.mjs';
export { unsafeEvalSupported } from './unsafeEvalSupported.mjs';
//# sourceMappingURL=index.mjs.map
